var map = {
	"./arrow-down-blue.svg": 395,
	"./arrow-down-grey.svg": 396,
	"./arrow-right-white.png": 397,
	"./arrow-right.svg": 398,
	"./avalanche_token_round.png": 207,
	"./big_unicorn.png": 130,
	"./blue-loader.svg": 133,
	"./circle-grey.svg": 399,
	"./circle.svg": 400,
	"./coinbaseWalletIcon.svg": 401,
	"./dropdown-blue.svg": 402,
	"./dropdown.svg": 403,
	"./dropup-blue.svg": 404,
	"./ethereum-logo.png": 405,
	"./fortmaticIcon.png": 406,
	"./link.svg": 407,
	"./magnifying-glass.svg": 408,
	"./menu.svg": 409,
	"./metamask.png": 206,
	"./noise.png": 132,
	"./plus-blue.svg": 410,
	"./plus-grey.svg": 411,
	"./portisIcon.png": 412,
	"./powered-by-avax.png": 208,
	"./question-mark.svg": 413,
	"./question.svg": 414,
	"./rabby.png": 415,
	"./spinner.svg": 416,
	"./token-list/lists-dark.png": 417,
	"./token-list/lists-light.png": 418,
	"./token-logo.png": 209,
	"./trustWallet.png": 419,
	"./walletConnectIcon.svg": 420,
	"./x.svg": 421,
	"./xl_uni.png": 131,
	"./yieldyak-logo-black.png": 134,
	"./yieldyak-logo-grey.png": 135,
	"./yieldyak-logo-white.png": 210
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 179;